import { useState, type FormEvent } from 'react';

const CTA_BG = 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20abstract%20background%20with%20warm%20red%20and%20amber%20light%20streaks%20flowing%20through%20darkness%2C%20mysterious%20glowing%20particles%20like%20breaking%20news%20signals%2C%20modern%20editorial%20atmosphere%20with%20cinematic%20lighting%2C%20clean%20negative%20space%20for%20text%20overlay%2C%20professional%20broadcast%20journalism%20aesthetic&width=1600&height=500&seq=cta-bg-subscribe&orientation=landscape';

export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注！');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt' && value) {
          params.append(key, value.toString());
        }
      });

      const res = await fetch('http://mengwenquda.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，最新爆料将第一时间发送到您的邮箱！');
        setEmail('');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (serverMsg && typeof serverMsg === 'string' && serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后再试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section id="subscribe" className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src={CTA_BG}
        alt="订阅背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/70 to-foreground-950/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 justify-between">
          <div className="max-w-lg">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-white mb-3">
              不想错过任何爆料？
            </h2>
            <p className="text-white/70 text-sm leading-relaxed">
              订阅黑料爆料吃瓜网，最新最劲爆的黑料爆料第一时间推送给你。
              网红塌房、明星聊天记录、博主反差视频，统统不错过！
            </p>
          </div>

          <div className="w-full max-w-md">
            <form
              id="subscribe-form"
             
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-3"
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱"
                required
                className="flex-1 px-5 py-3 rounded-full bg-white/10 border border-white/20 text-white text-sm placeholder:text-white/40 focus:outline-none focus:border-primary-400 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="whitespace-nowrap px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer"
              >
                {status === 'loading' ? '提交中...' : '立即订阅'}
              </button>
            </form>

            {status === 'success' && (
              <p className="mt-3 text-sm text-green-400 flex items-center gap-1.5">
                <i className="ri-checkbox-circle-line"></i> {message}
              </p>
            )}
            {status === 'error' && (
              <p className="mt-3 text-sm text-red-400 flex items-center gap-1.5">
                <i className="ri-error-warning-line"></i> {message}
              </p>
            )}

            <p className="mt-3 text-xs text-white/40">
              订阅即表示同意我们的
              <a href="#" className="underline hover:text-white/60 transition-colors">隐私政策</a>
              和
              <a href="#" className="underline hover:text-white/60 transition-colors">用户协议</a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}